

export function Sleep( msec : number){
    return new Promise(resolve => setTimeout(resolve, msec));
}